import Vue from "vue"
import dayjs from 'dayjs';
/**
 * [getTimeSection description] 根据天数获取起始时间段
 * @param  {[type]} days [description] 天数
 * @return {[type]}      [description]
 */
Vue.prototype.getDateRange = function (days, format = "YYYYMMDD") {
    var result = {};
    //初始化默认显示：默认近7日(今日:0,昨日:1,最近七日:7,最近30日:30,本月:-1,上月:-2)
    if (days === 0) {
        result.beginDay = dayjs();
        result.endDay = dayjs();
        result.label = '今日';
    } else {
        result.beginDay = dayjs().subtract(days - 1, 'days').format(format);
        result.endDay = dayjs().subtract(0, 'days').format(format);
        result.label = '近' + days + '日';
    }
    return result;
};
//将YYYYMMDD或者YYYY-MM-DD字符串转化为时间实例
Vue.prototype.dateFormat_date = function (day) {
    day = day.replace(/-/g, "");
    var new_date = day.substring(0, 4) + "/" + day.substring(4, 6) + "/" + day.substring(6, 8);
    var date = new Date(new_date);
    return date;
};
//根据开始时间和结束时间算出时间差，单位：天
Vue.prototype.dateFormat_dategap = function (beginday, endday) {
    if (typeof beginday === 'string')
        beginday = new Date(beginday);
    if (typeof endday === 'string')
        endday = new Date(endday);
    var date = endday.getTime() - beginday.getTime();
    var days = Math.ceil(date / (24 * 3600 * 1000));
    return days;
};
/**
 * [handleHtmlContent description] 处理html正文
 * @param  {[type]} htmlContent [description] 未处理的html正文
 * @return {[type]}             [description] 返回的html正文
 */
Vue.prototype.handleHtmlContent = function (htmlContent) {
    if (!htmlContent) {
        return;
    }
    else {
        let htmlContentArray = htmlContent.split("\n");
        htmlContentArray = htmlContentArray.map(item => {
            return `<p>${item}</p>`
        });
        htmlContent = htmlContentArray.join("");
        return htmlContent.replace(/\u0020{2}/g, '\u3000');
    }
};

/**
 * [loadCPsdk description] 加载云平台sdk
 * @return {[type]} [description]
 */
Vue.prototype.loadCPsdk = function (success = () => { }, failed = () => { }) {
    let self = this;
    if (!window.CP instanceof Object || !window.CP.ready instanceof Function) {
        failed();
    } else {
        CP.ready({
            debug: false,
            es6Require: false,
            tenantId: 'T_GOV',
            siteId: 'S_WDXW',
            wxOption: { //内容需要二次分享时请配置此项
                debug: false, //是否是开启微信调试模式
                //appid: 'wxdf1be0f2be8d4b49', //授权的微信公众号的appid  微信二次分享使用，具体使用方式请参照 附录：微信及微信二次分享  //废弃 后台内置
                method: 'getShareSign', //获取微信信息方法，写死
                uploadImage: '', //使用微信录音，图片上传等功能时需要的上传后台服务器地址
                redirect: window.location.href, //回调域名
                siteId: 'S_WDXW',
                tenantId: 'T_GOV',
                jsApiList: [
                    'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
                    'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'onVoicePlayEnd', 'uploadVoice', 'playVoice', 'getLocation',
                    'chooseImage', 'uploadImage', 'stopVoice', 'pauseVoice', 'previewImage', 'translateVoice', 'updateAppMessageShareData', 'updateTimelineShareData '
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见 附录：微信JS接口列表
            },
            ready: function (client_info) {
                //self.previewImg();
                window.st = client_info;
                //client_info > { client_code: 'web', version: '1.0', detail: ''}  clientInfo 接口返回数据
                success(client_info);
            },
            error: function (error) {
                console.log(error);
                //error > {code: 4000, msg: res.errMsg, data: res}  res为原生报错 微信的报错也在这处理
            }
        });
    }
};
/**
 * [setShare description] 稿件二次分享
 * @param {[type]} article [description] 稿件信息
 */
Vue.prototype.setShare = function (article, tenantId = 'T_GOV') {
    let content = this.getContent(article.docHtmlCon);
    if (!article.allowAppEmbedShare && window.st.clientInfo == "app_embed") { //允许在app环境内设置分享
        return;
    }
    delete article.allowAppEmbedShare;
    let self = this;
    //if (this.$store.state.clientInfo == 'app_embed') return;
    console.log('二次分享初始化');
    // let myLogo = this.rootUrl + logo;
    let shareSummary = article.abstract ? article.abstract : content.replace(/&nbsp;/ig, ' ').replace(/\n/g, '');
    shareSummary = shareSummary ? shareSummary : '分享自温州新闻APP客户端';
    CP.setShare({
        completed: function (data) {
            // data > {success:'1'}
            CP.tools.writelog('set_share', data);
        },
        cpIncompatible: function () {
            CP.tools.writelog('', '此环境不支持此方法');
        },
        'title': article.docTitle,
        'shareTo': '',
        'link': window.location.href,
        'imgUrl': window.location.origin + "/image/wenzhou_share_logo.png",
        'shareSummary': shareSummary.substring(0, 300), // article.share_summary.replace(/&nbsp;/ig, ' ').replace(/\n/g, ''),
        'id': article.docId,
        'type': '',
        'datatype': '',
        'dataUrl': '',
        'shareUrlScheme': '',
        'success': function () { console && console.log('用户已分享') }
    });
};
/**
 * [getContent description] 获取纯文本正文
 * @return {[type]} [description]
 */
Vue.prototype.getContent = function (htmlContent) {
    if (!htmlContent) return "";
    let div = document.createElement("div");
    div.innerHTML = htmlContent;
    return div.innerText;
};
/**
 * [previewImg description] 预览大图
 * @return {[type]} [description]
 */
Vue.prototype.previewImg = function (targetDom = 'img') {
    setTimeout(() => { // 延迟执行
        let $imgs = $(targetDom);
        let imgList = [];
        $imgs.each(function (index) {
            $(this).attr('imgIndex', index);
            imgList.push(this.src);
        });
        console.log(imgList);
        $imgs.click(e => {
            let $target = $(e.target);
            let index = $target.attr("imgIndex");
            CP.preview({
                once: true,
                completed: function (data) {
                    CP.tools.writelog('checkJsApi', data);
                },
                cpIncompatible: function () {
                    console.log('此环境不支持此方法');
                    CP.tools.writelog('', '此环境不支持此方法');
                },
                current: $target[0].src,
                target: index,
                imageList: imgList,
                urls: imgList
            });
        });
    }, 1000);
};

/**
 * [$downloadFile description] 下载文件
 * @param  {[type]} filePath [description] 文件路径
 * @param  {[type]} type     [description] 文件类型
 * @return {[type]}          [description]
 */
Vue.prototype.$downloadFile = function (filePath) {
    let downloadHref = `/digitalNewspaper/web/appendix/downLoadFile?filePath=${filePath}`
    window.open(downloadHref);
}